export default function masterVendorsDirective() {
  console.log('app.components.admin.vendorManagementAdmin.masterVendorsDirective created');
  return {
    template: require('./master-vendors.directive.html'),
    controller: 'VMAMasterVendorsDirectiveController',
    controllerAs: 'vmaMasterVendorsVM',
    bindToController: true,
    replace: true,
    scope: {
      masterVendors: '='
    },
  };
}
